/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { KTSVG } from '../../../helpers';
import { DropdownCustom5 } from '../../content/dropdown/DropdownCustom5';
import { useAppSelector } from '../../../../app/redux/hooks';
import { Link } from 'react-router-dom';
import { LINK_REGISTRATIOM_RENEWAL_DETAILS1, TEXT_CANT_RENEW_WARNING } from '../../../../app/constants';
import { useNavigate } from 'react-router-dom';

type Props = {
    className: string;
};

const ListsWidgetCustom8: React.FC<Props> = ({ className }) => {
    const user = useAppSelector((state) => state.user);
    const navigate = useNavigate();
    return (
        <div className='card card-xl-stretch mb-5 mb-xl-8'>
            {/* begin::Header */}
            <div className='card-header border-0'>
                <h3 className='card-title fw-bolder text-dark'>Notifications</h3>
                <div className='card-toolbar'>
                    {/* begin::Menu */}
                    <button
                        type='button'
                        className='btn btn-sm btn-icon btn-color-primary btn-active-light'
                        data-kt-menu-trigger='click'
                        data-kt-menu-placement='bottom-end'
                        data-kt-menu-flip='top-end'
                    >
                        <KTSVG path='/media/icons/duotune/general/gen024.svg' className='svg-icon-2' />
                    </button>
                    <DropdownCustom5 />
                    {/* end::Menu */}
                </div>
            </div>
            {/* end::Header */}
            {/* begin::Body */}
            <div className='card-body pt-0'>
                <div className='note-card d-flex align-items-center bg-light rounded p-5 mb-3'>
                    <div className='note-card-inner flex-grow-1 me-2'>
                        {user.renewalYear ? (
                            user.pfn_canrenew ? (
                                <button 
                                    type='button' 
                                    className='btn btn-primary fw-bolder me-5'
                                    onClick={() => navigate(LINK_REGISTRATIOM_RENEWAL_DETAILS1.value)}>
                                    Access Registration Renewal
                              </button>
                            ) : (
                                <div className="alert" role="alert">
                                    {TEXT_CANT_RENEW_WARNING.value}
                                </div>
                            )
                        ) : null }
                        {user.anyActiveInvoices && (
                            <Link to='/invoices/all' className='me-5'>
                                <button type='button' className='btn btn-primary fw-bolder'>
                                    Pay Invoices
                                </button>
                            </Link>
                        )}
                    </div>
                </div>
            </div>
            {/* end::Body */}
        </div>
    );
};

export { ListsWidgetCustom8 };
